import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_consume_report = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const canView  = hasPermission("Vehicle Diesel Consumption", "view");

    useEffect(() => {
    const fetchEquip = async () => {
      try {
         Swal.fire({
                                title: "Fetching Branches..",
                                html: `
                                  <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                                    <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                                  </div>
                                  <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Branches...</p>
                                `,
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                didOpen: () => {
                                  const style = document.createElement("style");
                                  style.innerHTML = `
                                    @keyframes progressBar {
                                      0% { width: 0% }
                                      50% { width: 100% }
                                      100% { width: 0% }
                                    }
                                  `;
                                  document.head.appendChild(style);
                                },
                              });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_consumereport_list_own`);
        setBranches(response.data.branches);
        Swal.close();
      } catch (error) {
          Swal.close();
                                console.error("Error fetching Vehicle Details. Please try again:", error);
                                Swal.fire({
                                  icon: "error",
                                  title: "Oops!",
                                  text: "Error fetching Vehicle Details. Please try again",
                                });
      }
      
    };
    {canView && (
    fetchEquip()
    )}
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/vehicle_consumereport_list_own?branch_code=${selectedBranch}`
        );
        setData(response.data.vehicles);
        setFilteredData(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedBranch) {
      fetchData();
    }
  }, [selectedBranch]);


  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        item.vehicle_name.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item.vehicle_number.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item.vehicle_type.toLowerCase().includes(e.target.value.toLowerCase())
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleSelection = (event) => {
    const value = event.target.value;
    if (value) {
      navigate('/vehicle_consumereport_list_hire');
    }
  };

   if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Own Vehicle-Diesel List</h2>
          <div>
            <Time />
          </div>
        </section>

           <div className="vehicle-class">
  <div>
    <p>Branch wise Report :</p>
                   <select 
            value={selectedBranch} 
            onChange={(e) => setSelectedBranch(e.target.value)} 
            required 
            className="branch-select"
          >
            <option value="">Select Branch</option>
            {branches.map((item) => (
              <option key={item.branchMaster_code} value={item.branchMaster_code}>
                {item.branchMaster_name}
              </option>
            ))}
          </select>
  </div>

  <div>
    <p>Select your vehicle:</p>
    <select className="branch-select" onChange={handleSelection}>     
<option value="/own">Own Vehicle</option>   
            <option value="/hire">Hire Vehicle</option>    
            
    </select>
  </div>
</div>

      
        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Vehicle Name, Number, or Type"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Code</th>
                <th>Vehicle Number</th>
                <th>Date</th>
                <th>Vehicle Name</th>
                <th>Vehicle Type</th>
                <th>Vehicle Basis</th>
              </tr>
            </thead>
            <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="6" className="loading-text">
                                Loading data, please wait...
                              </td>
                            </tr>
                          ) : currentData.length > 0 ? (
                            currentData.map((item, index) => (
                              <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/own_vehicleconsume_report/${item.vehicle_code}/${item.branch_code}`}>{item.vehicle_code}</Link>
                    </td>
                    <td>{item.vehicle_number}</td>
                    <td>{item.vehicle_regdate ? new Date(item.vehicle_regdate).toLocaleDateString('en-GB') : ''}</td>
                    <td>{item.vehicle_name}</td>
                    <td>{item.vehicle_type}</td>
                    <td>{item.vehicle_basis}</td>
                  </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6">No Data Available</td>
                            </tr>
                          )}
                        </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_consume_report;
